/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $LeagueMatchImportResponseList = {
    type: 'array',
    contains: {
        type: 'any-of',
        contains: [{
            type: 'LeagueMatchImportRequest_Output',
        }, {
            type: 'string',
        }],
    },
} as const;
